<template>
  <q-dialog v-model="aberto" persistent>
    <q-card style="min-width: 480px; max-width: 560px; border-radius: 12px">
      <!-- Cabeçalho -->
      <q-card-section class="row items-center q-pb-none">
        <div class="col">
          <div class="text-h6 text-brand-1 text-weight-bold">
            Hora de uma reciclagem! 🔄
          </div>
          <div class="text-caption text-grey-6 q-mt-xs">
            Já está na hora de se atualizar na plataforma Multpex
          </div>
        </div>
        <q-btn
          icon="close"
          flat
          round
          dense
          @click="mensagemVideos ? abrirVideosEFechar() : fechar()"
        />
      </q-card-section>

      <q-separator class="q-mt-sm" />

      <!-- Conteúdo -->
      <q-card-section class="q-pt-md" v-if="!mensagemVideos">
        <p class="text-body2 text-grey-7">
          Já está na hora de uma reciclagem de treinamento aqui no Multpex! Você
          pode fazer isso assistindo nossos vídeos de treinamento, ou agendando
          uma sessão completa com nossa equipe. E se você se sente confortável
          em operar o sistema e não acha que precisa de ajuda por hora, pode nos
          dizer isso também!
        </p>
      </q-card-section>

      <q-separator v-if="!mensagemVideos" />

      <!-- Opções -->
      <q-card-section v-if="!mensagemVideos" class="q-gutter-sm q-pt-md">
        <!-- Opção 1: Vídeos -->
        <q-card
          flat
          bordered
          class="opcao-card cursor-pointer"
          :class="{ 'opcao-loading': loadingOpcao === 1 }"
          @click="opcaoVideos"
        >
          <q-card-section class="row items-center q-py-sm">
            <q-icon
              name="play_circle_outline"
              size="28px"
              color="deep-orange"
              class="q-mr-md"
            />
            <div class="col">
              <div
                class="text-weight-bold text-brand-1"
                style="font-size: 13px"
              >
                Revisar os vídeos de treinamento
              </div>
              <div class="text-caption text-grey-6">
                Consulte e refresque o conteúdo no seu ritmo
              </div>
            </div>
            <q-spinner
              v-if="loadingOpcao === 1"
              color="deep-orange"
              size="20px"
            />
          </q-card-section>
        </q-card>

        <!-- Opção 2: Calendário -->
        <q-card
          flat
          bordered
          class="opcao-card cursor-pointer"
          :class="{ 'opcao-loading': loadingOpcao === 2 }"
          @click="opcaoCalendario"
        >
          <q-card-section class="row items-center q-py-sm">
            <q-icon name="event" size="28px" color="primary" class="q-mr-md" />
            <div class="col">
              <div
                class="text-weight-bold text-brand-1"
                style="font-size: 13px"
              >
                Agendar uma sessão completa com a equipe
              </div>
              <div class="text-caption text-grey-6">
                Escolha um horário no nosso calendário de atendimento
              </div>
            </div>
            <q-spinner v-if="loadingOpcao === 2" color="primary" size="20px" />
          </q-card-section>
        </q-card>

        <!-- Opção 3: Confortável -->
        <q-card
          flat
          bordered
          class="opcao-card cursor-pointer"
          :class="{ 'opcao-loading': loadingOpcao === 3 }"
          @click="opcaoConfortavel"
        >
          <q-card-section class="row items-center q-py-sm">
            <q-icon
              name="thumb_up_off_alt"
              size="28px"
              color="teal"
              class="q-mr-md"
            />
            <div class="col">
              <div
                class="text-weight-bold text-brand-1"
                style="font-size: 13px"
              >
                Estou confortável com o uso do sistema
              </div>
              <div class="text-caption text-grey-6">
                Me sinto à vontade com a plataforma
              </div>
            </div>
            <q-spinner v-if="loadingOpcao === 3" color="teal" size="20px" />
          </q-card-section>
        </q-card>
      </q-card-section>

      <!-- Mensagem pós vídeos -->
      <q-card-section v-if="mensagemVideos" class="q-pt-md q-pb-lg text-center">
        <q-icon
          name="play_circle_outline"
          size="56px"
          color="deep-orange"
          class="q-mb-sm"
        />
        <p class="text-h6 text-brand-1 text-weight-bold q-mb-xs">
          Boa escolha! Vamos refrescar o conhecimento.
        </p>
        <p class="text-body2 text-grey-7 q-px-md">
          Ao clicar no botão abaixo você será levado direto para nossa
          biblioteca de vídeos de treinamento. Fique à vontade para rever o
          conteúdo quando precisar — a página fica disponível para você sempre,
          quantas vezes quiser.
        </p>
        <q-btn
          label="Ir para os vídeos de treinamento"
          no-caps
          icon="play_circle_outline"
          style="background-color: #21324a; border-radius: 8px; color: white"
          class="q-mt-md"
          @click="abrirVideosEFechar"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { avisoTreinamentoService } from "../services/avisoTreinamentoService";

const CALENDAR_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0H7LwFcOAL-TVrk0RNCKmPJs2zCg0ou_Vjh7Fq6CT7wJufOhmw0ABXVPwP3KLDXvGmUnhcnnP1";
const VIDEOS_URL =
  "https://sites.google.com/multpex.com.br/basedeconhecimento/tutoriais-consolidados-em-v%C3%ADdeos?authuser=0";

export default {
  name: "AvisoTreinamentoVideosVencidoModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    userEmail: {
      type: String,
      default: "",
    },
    docId: {
      type: String,
      default: null,
    },
    userSap: {
      type: String,
      default: null,
    },
    userName: {
      type: String,
      default: null,
    },
    tipoTreinamentoWeb: {
      type: String,
      default: null,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const aberto = ref(props.modelValue);
    const loadingOpcao = ref(null);
    const mensagemVideos = ref(false);

    watch(
      () => props.modelValue,
      (val) => {
        aberto.value = val;
      }
    );

    watch(aberto, (val) => {
      emit("update:modelValue", val);
    });

    const fechar = () => {
      aberto.value = false;
    };

    const executarOpcao = async (opcao, motivo, callback) => {
      loadingOpcao.value = opcao;
      await avisoTreinamentoService.notificarWebhook(
        motivo,
        props.userEmail,
        null,
        props.docId,
        props.userSap,
        props.userName,
        props.tipoTreinamentoWeb
      );
      if (callback) callback();
      loadingOpcao.value = null;
      fechar();
    };

    const abrirVideosEFechar = () => {
      window.open(VIDEOS_URL, "_blank");
      fechar();
    };

    const opcaoVideos = async () => {
      loadingOpcao.value = 1;
      await avisoTreinamentoService.notificarWebhook(
        "videos",
        props.userEmail,
        null,
        props.docId,
        props.userSap,
        props.userName,
        props.tipoTreinamentoWeb
      );
      loadingOpcao.value = null;
      mensagemVideos.value = true;
    };

    const opcaoCalendario = () => {
      executarOpcao(2, "calendario", () => {
        window.open(CALENDAR_URL, "_blank");
      });
    };

    const opcaoConfortavel = () => {
      executarOpcao(3, "confortavel");
    };

    return {
      aberto,
      loadingOpcao,
      mensagemVideos,
      fechar,
      abrirVideosEFechar,
      opcaoVideos,
      opcaoCalendario,
      opcaoConfortavel,
    };
  },
};
</script>

<style scoped>
.opcao-card {
  border-radius: 8px !important;
  transition: background-color 0.2s;
}
.opcao-card:hover {
  background-color: #f5f7fa;
}
.opcao-loading {
  opacity: 0.7;
  pointer-events: none;
}
</style>
